import { SAVE_PROFIL_CLIENT, CLEAR_PROFIL_CLIENT } from './types';

export const SaveProfilClient = (data) => dispatch => {
  dispatch({ type: SAVE_PROFIL_CLIENT, value : data });
}

export const DeleteProfilClient = () => dispatch => {
  dispatch({ type: CLEAR_PROFIL_CLIENT });
}
